import gql from 'graphql-tag';

export const GET_VENUE_STATISTICS = gql`
  query getVenueStatistics($params: VenueInput!) {
    cnTransactionCountsForVenueByMarketplace(params: $params) {
      DOSH {
        AMEX
        VISA
        MASTERCARD
        total
      }
    }

    averageTransactionAmountForVenue(params: $params) {
      averageTransactionAmount
    }

    lastTransactionDate(params: $params) {
      transactionTimestamp
    }
  }
`;

export default GET_VENUE_STATISTICS;
